import {Component} from '@angular/core';

/* Body only -- HelpDialogComponent supplies the dialog chrome and Okay button. */
@Component({
    selector: 'app-inventory-help',
    templateUrl: './inventory-help.component.html'
})
export class InventoryHelpComponent {
}
